import { useDroppable } from "@dnd-kit/core";

export function DroppableArea({ id, disabled, children, className = "", overClassName = "" }) {
  const { setNodeRef, isOver } = useDroppable({ id, disabled });
  return (
    <div
      ref={setNodeRef}
      className={`${className} ${isOver ? overClassName : ""}`}
      data-drop-over={isOver ? "1" : undefined}
    >
      {children}
    </div>
  );
}
